﻿import { createPopper } from '@popperjs/core';

export class NavbarMenu {
	submenu: HTMLElement;
	popper: HTMLElement;
	visible: boolean = false;

	constructor(submenu: HTMLElement, popper: HTMLElement) {
		this.submenu = submenu;
		if (!this.submenu) {
			return;
		}
		this.submenu.addEventListener('click', this.onClick.bind(this));
		this.popper = popper;
		createPopper(this.submenu, this.popper, {
			placement: 'bottom-start',
		});
		document.onclick = (e: Event) => {
			this.hide();
		};
	}

	show() {
		this.visible = true;
		this.popper.style.display = 'block';
		this.popper.style.top = '-12px';
		this.popper.style.width = '186px';
		this.popper.style.borderTop = '3px solid #599B81';
		this.popper.style.display = 'flex';
		this.popper.style.flexDirection = 'column';
		this.popper.style.alignItems = 'center';
	}

	hide() {
		this.visible = false;
		this.popper.style.display = 'none';
	}

	private onClick = (e: Event) => {
		e.preventDefault();
		e.stopPropagation();
		if (this.visible) {
			this.hide();
		} else {
			this.show();
		}
	};
}

export function updateNavbar() {
	const navbar = document.querySelector('.corp-header');
	const scrollTop = document.scrollingElement.scrollTop;
	if (scrollTop <= 600) {
		if (navbar.classList.contains('fixed-in')) {
			navbar.classList.remove('fixed-in');
			if (!navbar.classList.contains('fixed-out')) {
				navbar.classList.add('fixed-out');
			}
		}
	} else {
		if (navbar.classList.contains('fixed-out')) {
			navbar.classList.remove('fixed-out');
		}
		if (!navbar.classList.contains('fixed-in')) {
			navbar.classList.add('fixed-in');
		}
	}
}
